import React from 'react';
import Badge from '../Badge';
import { Professor } from '../../interfaces/professor';

interface ProfessorTitleProps {
    professor: Professor;
    includeBadge?: boolean;
    includeUni?: boolean;
    badgeSize?: 'small' | 'medium' | 'large';
}

/**
 * Displays a professor's name as a link, optionally including their university
 * abbreviation and a badge.
 */
const ProfessorTitle: React.FC<ProfessorTitleProps> = ({
    professor,
    includeBadge = false,
    includeUni = false,
    badgeSize = 'small',
}) => {
    // Ensure uni is a string, even if professor.uni is undefined/null
    const uniAbbreviation = professor.uni ?? ''; // Use nullish coalescing (??) for potentially null/undefined

    // Construct the display name
    const displayName = `${professor.first_name} ${professor.last_name}`;
    const titleText =
        includeUni && uniAbbreviation
            ? `[${uniAbbreviation}] ${displayName}`
            : displayName;

    return (
        <>
            <a
                className="mr-10"
                href={`/professor/${professor.professor_id}`}
                title={`View details for Professor ${displayName}`} // Add a title attribute for accessibility
            >
                {titleText}
            </a>
            {/* Render Badge only if includeBadge is true AND professor.nugget has a value */}
            {includeBadge && professor.nugget != null && (
                <Badge badgeId={professor.nugget} />
            )}
        </>
    );
};

export default ProfessorTitle;
